import { Link } from "react-router-dom";
import { memo, useEffect, useState } from "react";
import logo from "../../images/Sibi_Logo/1536x1024 (2).png";
// import QRCode from "../../images/QRCode.png"
import { ECommerce } from "api/AppConfigApi";

// Brand-color social icons
const SocialLinks = [
  {
    label: "facebook",
    color: "#6b5330",
    icon: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
  },
  {
    label: "instagram",
    gradient: "linear-gradient(45deg,#6b5330,#6b5330,#6b5330,#6b5330,#6b5330)",
    icon: <svg viewBox="0 0 24 24" fill="white"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
  },
  {
    label: "youtube",
    color: "#6b5330",
    icon: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23.495 6.205a3.007 3.007 0 00-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 00.527 6.205a31.247 31.247 0 00-.522 5.805 31.247 31.247 0 00.522 5.783 3.007 3.007 0 002.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 002.088-2.088 31.247 31.247 0 00.5-5.783 31.247 31.247 0 00-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/></svg>
  },
  {
    label: "whatsapp",
    color: "#6b5330",
    icon: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
  },
];

function Footer({ branch, configImages }) {
  // const { dispatch } = useCartContext();
  // const history = useNavigate();
  const [gatwayIcon, setgatwayIcon] = useState("");
  const [socialMedia, setSocialMedia] = useState([]);

  useEffect(() => {
    Promise.all([
      getPaymentAppConfigData()
    ])
    .then(() => {
      configImages.PGIMAGES?.forEach((d) => { if (d.key === "paymentGatway") setgatwayIcon(d.value); });
    })
    .catch(console.error())
  }, []); // eslint-disable-line

  const getPaymentAppConfigData = () => {
    let filter = "social_media_config"
    const response = ECommerce(filter);
    response.then(
      (data) => {
         const moduleData = JSON.parse(data.response.moduleField);
         setSocialMedia(moduleData)
      }
    )
    return response
  }

  // const handleOrderClick = () => {
  //   if (!getCustomerId()) dispatch({ type: "MODAL", payload: "login" });
  //   else history("/ProductOrderDetails");
  // };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("app") === "1") {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      const PLAYSTORE_URL = "https://play.google.com/store/apps/details?id=com.ri.zinger.sibirajajewellers&hl=en_IN";
      const APPSTORE_URL = "https://apps.apple.com/us/app/sibiraja-nagai-maligai/id6741752073";
      window.location.replace(isIOS ? APPSTORE_URL : PLAYSTORE_URL);
    }
  }, []);

  return (
    <footer className="ej-footer">
      {/* Main body */}
      <div className="ej-footer-body">
        <div className="container">
          <div className="ej-footer-grid">
            {/* Brand */}
            <div className="ej-footer-brand">
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <img
                  src={logo}
                  alt="Sibiraja Nagai Maaligai LLP"
                  className="ej-footer-logo"
                />
              </div>
              <p className="ej-footer-tagline">
                Crafting timeless jewellery with unmatched artistry since
                generations. Every piece tells a story of tradition and
                elegance.
              </p>
              <div className="ej-app-box mb-5">
                <h3 style={{ fontSize: "15px"}}>Download the App</h3>
                <p style={{ fontSize: "12px"}}>Shop & Save more on app by redeeming exclusive points</p>
                <div className="ej-store-buttons">
                  <img
                    src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                    alt="App Store"
                  />
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                    alt="Google Play"
                  />
                  </div>
              </div>
              <span style={{ fontWeight: 900 }}>Find Us On</span>
              <div className="ej-footer-socials mt-3">
                {Array.isArray(socialMedia) &&
                  socialMedia
                    .filter((item) => item.key?.toLowerCase() !== "google")
                    .map((item, i) => {
                      const matched = SocialLinks.find(
                        (s) => s.label.toLowerCase() === item.key?.toLowerCase()
                      );
                      if (!matched || !item.value) return null;
                      return (
                        <a
                          key={i}
                          href={item.value}
                          target="_blank"
                          rel="noreferrer"
                          aria-label={matched.label}
                          className="ej-footer-social"
                          style={
                            matched.gradient
                              ? { background: matched.gradient }
                              : { background: matched.color }
                          }
                        >
                          <span
                            style={{
                              width: 16,
                              height: 16,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {matched.icon}
                          </span>
                        </a>
                      );
                    })}
              </div>
            </div>

            {/* Policies */}
            <div className="ej-footer-col">
              <h5 className="ej-footer-heading">Policies</h5>
              <ul className="ej-footer-links">
                {[
                  { label: "Terms & Conditions", to: "TermsConditions" },
                  { label: "Privacy Policy", to: "PrivacyPolicy" },
                  { label: "Shipping Policy", to: "ShippingPolicy" },
                  { label: "Refund Policy", to: "RefundPolicy" },
                ].map((p, i) => (
                  <li key={i}>
                    <Link to={p.to} className="ej-footer-link">
                      {p.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links */}
            <div className="ej-footer-col">
              <h5 className="ej-footer-heading">Quick Links</h5>
              <ul className="ej-footer-links">
                {[
                  { label: "Home", to: "/" },
                  { label: "About Us", to: "About" },
                  { label: "Products", to: "ProductList" },
                  { label: "New Arrivals", to: "NewArrivals" },
                  { label: "Most Liked", to: "MostLiked" },
                  // { label: "Referral Points", to: "ReferralPoints" },
                ].map((l, i) => (
                  <li key={i}>
                    <Link to={l.to} className="ej-footer-link">
                      {l.label}
                    </Link>
                  </li>
                ))}
                {/* <li>
                  <button
                    onClick={handleOrderClick}
                    className="ej-footer-link ej-footer-link-btn"
                  >
                    Order Details
                  </button>
                </li> */}
              </ul>
            </div>

            {/* Contact */}
            <div className="ej-footer-col">
              <h5 className="ej-footer-heading">Contact Us</h5>
              <ul className="ej-footer-contact">
                {Object.keys(branch).length > 0 && (
                  <li className="ej-footer-contact-item">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    >
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                    <span>
                      {branch.branchAddress?.address1}
                      {branch.branchAddress?.address2}
                    </span>
                  </li>
                )}
                {branch.mobile && (
                  <li className="ej-footer-contact-item">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    >
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.95 9.91a19.79 19.79 0 01-3.07-8.67A2 2 0 012.88 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                    </svg>
                    <span>+91 {branch.mobile}</span>
                  </li>
                )}
                {branch.email && (
                  <li className="ej-footer-contact-item">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                    <a
                      href={`mailto:${branch.email}`}
                      className="ej-footer-email"
                    >
                      {branch.email}
                    </a>
                  </li>
                )}
              </ul>

              {/* App QR */}
              <div className="ej-footer-qr-wrap">
                  <img
                    src={`https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${encodeURIComponent(`${window.location.origin}/?app=1`)}`}
                    alt="Download App"
                    className="ej-footer-qr"
                  />
              </div>
              <div className="mt-5 pt-5">
              {gatwayIcon && (
                <img
                  src={gatwayIcon}
                  alt="Payment"
                  className="ej-footer-payment"
                />
              )}
            </div>
            </div>
          </div>
        </div>
      </div>


      {/* Bottom bar */}
      <div className="ej-footer-bottom">
        <div className="container pb-3">
          <div className="ej-footer-bottom-row float-end">
            <p className="ej-footer-copy">
              © 2026 SIBIRAJA NAGAI MAALIGAI LLP. All rights reserved.
              Designed by{" "}
              <a
                href="https://rasiinfotech.com/"
                className="ej-footer-copy-link"
              >
                Rasi Infotech
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default memo(Footer);